var map = {
	"./App": 4909,
	"./App.vue": 4909,
	"./assets/appick.png": 5192,
	"./assets/avatar.png": 4211,
	"./assets/award.svg": 8709,
	"./assets/bg.png": 1469,
	"./assets/c.svg": 9585,
	"./assets/circle.png": 2628,
	"./assets/cpp.svg": 5417,
	"./assets/css.svg": 51,
	"./assets/dj.png": 5313,
	"./assets/flutter.svg": 5620,
	"./assets/fp.png": 5694,
	"./assets/html.svg": 6237,
	"./assets/hu.png": 4221,
	"./assets/js.svg": 6571,
	"./assets/logo.png": 3153,
	"./assets/logo.svg": 3935,
	"./assets/php.svg": 9898,
	"./assets/python.svg": 532,
	"./assets/saaya.png": 8717,
	"./assets/scholar.svg": 1476,
	"./assets/securiti.svg": 8076,
	"./assets/stpats.png": 3999,
	"./assets/top50-badge.svg": 562,
	"./assets/uoc.png": 4801,
	"./assets/veeam.png": 7756,
	"./assets/vuejs.svg": 1267,
	"./assets/wp.svg": 2775,
	"./components/About": 8478,
	"./components/About.vue": 8478,
	"./components/AchievementCard": 1531,
	"./components/AchievementCard.vue": 1531,
	"./components/Achievements": 2494,
	"./components/Achievements.vue": 2494,
	"./components/CommunityProjects": 6734,
	"./components/CommunityProjects.vue": 6734,
	"./components/Contact": 7079,
	"./components/Contact.vue": 7079,
	"./components/Education": 4195,
	"./components/Education.vue": 4195,
	"./components/Footer": 8691,
	"./components/Footer.vue": 8691,
	"./components/HelloWorld": 383,
	"./components/HelloWorld.vue": 383,
	"./components/ProgrammingLanguages": 5872,
	"./components/ProgrammingLanguages.vue": 5872,
	"./components/ProjectCard": 120,
	"./components/ProjectCard.vue": 120,
	"./components/Projects": 4334,
	"./components/Projects.vue": 4334,
	"./components/Research": 940,
	"./components/Research.vue": 940,
	"./components/WorkExperience": 5527,
	"./components/WorkExperience.vue": 5527,
	"./data": 5247,
	"./data/": 5247,
	"./data/index": 5247,
	"./data/index.js": 5247,
	"./data/portfolio": 4318,
	"./data/portfolio.json": 4318,
	"./main": 6269,
	"./main.js": 6269,
	"./plugins/vuetify": 8571,
	"./plugins/vuetify.js": 8571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;